export default __webpack_public_path__ + "static/media/ply2.1784016a.svg";